<template>
  <v-card :flat="flat" class="lista-imovel-card">
    <router-link :to="{ name: 'ImoveisDetalhesResumo', params: { id: imovel.id } }">
      <v-card-text class="pt-4 pb-4 lista_imoveis">
        <v-layout row wrap align-center style="min-height: 50px;">
          <v-flex xs12 md6 xl8>
            <span class="subheading">
              <span v-if="exibirStatus" class="status_circulo" :style="{ 'background-color': statusColor }"></span>
              <strong>{{ imovel.apelido || fallbackTitulo }}</strong>
            </span>
            <div class="grey--text text--darken-1 mt-1" v-if="formattedEndereco">
              {{ formattedEndereco }}
            </div>
            <div class="grey--text text--darken-1 mt-2" v-if="imovel.tipo || imovel.proprietario">
              <span v-if="imovel.tipo" class="mr-3"><span class="caption secondary--text"><strong>Tipo</strong></span> {{ imovel.tipo }}</span>
              <span v-if="imovel.proprietario"><span class="caption secondary--text"><strong>Proprietário</strong></span> {{ imovel.proprietario }}</span>
            </div>
          </v-flex>
          <v-flex xs12 md6 xl4 class="status-coluna" v-if="$hasGranularPermission('vistoria', 'view') || $hasGranularPermission('tarefas', 'view')">
            <v-layout row>
              <v-flex xs12 sm6 v-if="$hasGranularPermission('vistoria', 'view')">
                <ListaVistoriaSituacao v-if="vistoriaSituacao" :situacao="vistoriaSituacao"></ListaVistoriaSituacao>
                <v-btn v-else outline block class="secondary secondary--text ma-0 caption">Sem vistoria</v-btn>
              </v-flex>
              <v-flex xs12 sm6 class="tarefas-coluna" v-if="$hasGranularPermission('tarefas', 'view')">
                <v-btn outline block class="grey grey--text ma-0 caption">
                  <template v-if="tarefasPendentesCount === 1"><span class="headline">1 &nbsp;</span>tarefa</template>
                  <template v-else-if="tarefasPendentesCount > 1"><span class="headline">{{ tarefasPendentesCount }} &nbsp;</span>tarefas</template>
                  <template v-else>Sem tarefas</template>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </router-link>
  </v-card>
</template>

<script>
  import _ from 'lodash'
  import ListaVistoriaSituacao from './ListaVistoriaSituacao'

  export default {
    props: ['imovel', 'flat', 'exibirStatus'],
    components: {
      ListaVistoriaSituacao
    },
    computed: {
      fallbackTitulo () {
        return this.imovel && this.imovel.id ? `Imóvel #${this.imovel.id}` : 'Imóvel'
      },
      statusName () {
        return _.get(this.imovel, 'status.data.status')
      },
      statusColor () {
        return this.colors[this.statusName] || this.colors.undefined
      },
      formattedEndereco () {
        const endereco = _.get(this.imovel, 'endereco.data')
        if (!endereco) return ''
        return this.formatarEndereco(endereco)
      },
      tarefasPendentesCount () {
        return this.countTarefasPendentes(_.get(this.imovel, 'tarefas.data', []))
      },
      vistoriaSituacao () {
        return _.get(this.imovel, 'vistoria.data.situacao', '')
      }
    },
    data () {
      return {
        colors: {
          undefined: 'grey',
          Vago: '#EDC109',
          Compromissado: '#EA5DDF',
          Locado: '#4FBF46',
          Comodato: '#006AB6',
          Invadido: '#ED1B09'
        }
      }
    },
    methods: {
      formatarEndereco (endereco) {
        if (!endereco || typeof endereco !== 'object') return ''
        const logradouro = _.filter([`${endereco.tipo} ${endereco.logradouro}`, endereco.numero, endereco.complemento]).join(', ')
        const cidade = _.filter([logradouro, endereco.cidade, endereco.uf]).join(' - ')

        return cidade
      },
      countTarefasPendentes (tarefas) {
        if (!Array.isArray(tarefas)) return 0
        return _.filter(tarefas, { realizada: false }).length
      }
    }
  }
</script>


<style scoped>
  .lista-imovel-card {
    padding-left: 48px;
  }

  .status_circulo { display: inline-block; height: 14px; width: 14px; border-radius: 100%; vertical-align: middle; margin-right: 4px; margin-top: -4px; }

  @media (max-width: 959px) {
    .lista-imovel-card {
      padding-left: 0;
    }

    .lista_imoveis {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .status-coluna {
      margin-top: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// ListaImovel.vue?5a00516a